module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4zzj.25b43aa1.jpg";